import React from 'react'
import ModalBasic from '../../component/ModalBasic'
import TextInput from '../../../components/UIComponent/TextInput'
import MultiSelectDropdown from '../../../components/dropdown/MultiSelectDropdown'

export const CityMasterPopup = (props) => {
    return (
        <ModalBasic
            id="cityMaster"
            classParams="!w-[55%]"
            modalOpen={props.isModalOpen}
            setModalOpen={props.setOpenModel}
        >
            <div className='input-fields p-[30px]'>
                <span className="text-blue text-[16px] font-semibold">City details</span>
                <div className='item-grp grid grid-cols-1 gap-2.5 mt-3 mb-3'>
                    <div className='input-grp'>
                        <label>Select country</label>
                        <MultiSelectDropdown
                            drpIdentity="Account head"
                            options={props.cityObject.countryList}
                            value={props.cityObject.idCountry ? props.cityObject.countryList.find(x => x.value === props.cityObject.idCountry) : 0}
                            onChange={(selected) =>
                                props.handleChangeFroDropdown(selected, "idCountry")
                            }
                            className={props.validState?.error?.idCountry !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Select state</label>
                        <MultiSelectDropdown
                            drpIdentity="State"
                            options={props.cityObject.stateList}
                            value={props.cityObject.idState ? props.cityObject.stateList.find(x => x.value === props.cityObject.idState) : 0}
                            onChange={(selected) =>
                                props.handleChangeFroDropdown(selected, "idState")
                            }
                            className={props.validState?.error?.idState !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>City name</label>
                        <TextInput type='text'
                            id='cityName' name='cityName'
                            value={props.cityObject.cityName}
                            handleChange={(event) => props.handleChange(event, 'cityName')}
                            className={props.validState?.error?.cityName !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Remarks</label>
                        <TextInput type='text'
                            id='remarks' name='remarks'
                            value={props.cityObject.remarks}
                            handleChange={(event) => props.handleChange(event, 'remarks')}
                        />
                    </div>
                </div>

                <div className='btn-grp flex gap-2.5 mt-5'>
                    <button className="update-btn btns" onClick={() => props.submit()}>Save</button>
                    <button className="delete-btn btns" onClick={() => props.close()}>Cancel</button>
                </div>
            </div>

        </ModalBasic>
    )
}